import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

// import islandLogo from '../assets/images/island_logo.png';

const Login = (): React.ReactElement => {
  const { t } = useTranslation('login');

  const island = () => {
    window.location.href = '/application-v1/account/island/';
  };

  return (
    <Container className="pt-5">
      {/* <img src={logoBlack} className="d-block mx-auto" alt="Vala Vinnuskóli" /> */}

      <strong className="text-center mt-3 d-block" style={{ textTransform: 'uppercase' }}>
        Raunfærnimat
      </strong>

      <Row className="justify-content-center">
        <Col xl="6" lg="8" md="5">
          <Card className="o-hidden my-5">
            <div className="p-5">
              <div className="text-center">
                <h1 className="h4 text-gray-900 mb-4">{t('title')}</h1>
              </div>

              <Button variant="primary" className="w-100" onClick={island}>
                {/* <img src={islandLogo} alt="Ísland.is" height="30" style={{ marginTop: '-5px' }} className="pr-2" /> */}
                <span className="d-inline-block mt-1">{t('icekeylogin')}</span>
              </Button>
            </div>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
